export default "__VITE_ASSET__DGYQYDth__"